import { z } from "zod";

// Public links may contain arbitrary campaign parameters. Strip unknown keys
// from typed search state and treat malformed known values as missing.
export const signupSearchSchema = z.object({
  // reason: explicitly supported inbound email links prefill signup (FE-SEC7).
  // The form does not write email edits back to the URL.
  email: z.string().optional().catch(undefined),
});

export const loginSearchSchema = z.object({
  stage: z.enum(["enter-email", "check-email"]).optional().catch(undefined),
});

export const authTokenSearchSchema = z.object({
  token: z.string().optional().catch(undefined),
});

export const verifySearchSchema = authTokenSearchSchema.extend({
  // VerifyRoute still checks isSafeOAuthReturnTo before following a destination.
  returnTo: z.string().optional().catch(undefined),
});

export const authErrorSearchSchema = z.object({
  reason: z.string().optional().catch(undefined),
});

export const googleHandoffSearchSchema = z.object({
  handoff: z.string().optional().catch(undefined),
});
